import { Controller } from "@hotwired/stimulus"

// Shows a preview of the image picked in a file input.
// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["input", "image", "placeholder"]

  disconnect() {
    this.revoke()
  }

  show() {
    const file = this.inputTarget.files[0]
    if (!file) return

    this.revoke()
    this.objectUrl = URL.createObjectURL(file)
    this.imageTarget.src = this.objectUrl
    this.imageTarget.classList.remove("hidden")
    this.placeholderTarget.classList.add("hidden")
  }

  revoke() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl)
      this.objectUrl = null
    }
  }
}
